import { useState, useEffect } from 'react';
import { pushNotificationsApi } from '../../api/notificationApis/push-notifications.api'; // Adjust path

const urlBase64ToUint8Array = (base64String: string) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const usePushNotifications = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [subscription, setSubscription] = useState<PushSubscription | null>(null);

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      setIsSupported(true);
      registerServiceWorker();
    }
  }, []);

  const registerServiceWorker = async () => {
    try {
let registration = await navigator.serviceWorker.getRegistration();

if (!registration) {
  registration = await navigator.serviceWorker.register("/sw.js");
}

await navigator.serviceWorker.ready;

const sub = await registration.pushManager.getSubscription();
setSubscription(sub);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  };

 const subscribeToPush = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        throw new Error('Notification permission not granted');
      }

      const registration = await navigator.serviceWorker.ready;
      
      // 🟢 1. Grab the key using Vite's syntax
      const publicVapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY; 
      
     

      if (!publicVapidKey) {
        console.error("❌ VAPID Key is missing! Did you rename it to VITE_VAPID_PUBLIC_KEY and restart the server?");
        throw new Error("Missing VAPID key");
      }

      // 2. Convert it
      const convertedVapidKey = urlBase64ToUint8Array(publicVapidKey);

    

      // 3. Subscribe (THIS IS WHERE BRAVE BLOCKS YOU)
     let newSubscription = await registration.pushManager.getSubscription();

if (!newSubscription) {
  newSubscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: convertedVapidKey,
  });
}

setSubscription(newSubscription);
await pushNotificationsApi.subscribe(newSubscription);
    

      

    } catch (error) {
      console.error('❌ Failed to subscribe to push notifications:', error);
      throw error; // This throws it back to the button so the loading spinner stops
    }
  };

  const unsubscribeFromPush = async () => {
    try {
      if (subscription) {
        await pushNotificationsApi.unsubscribe(subscription.endpoint);
        await subscription.unsubscribe();
        setSubscription(null);
      }
    } catch (error) {
      console.error('Failed to unsubscribe', error);
      throw error;
    }
  };

  // 🟢 NEW: API call wrapped securely inside the hook
  const testPushNotification = async () => {
    try {
      await pushNotificationsApi.testNotification();
    } catch (error) {
      console.error('Failed to send test notification', error);
      throw error;
    }
  };

  return {
    isSupported,
    isSubscribed: !!subscription,
    subscribeToPush,
    unsubscribeFromPush,
    testPushNotification, // 🟢 Exported here
  };
};